export default "__VITE_ASSET__i6YfTW2e__"